import UserContentHeader from "../../../user/header/usercontentheader/usercontentheader";
import Button from "../../../../core/button/button";
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import {SimpleTable} from "../../../../modals/types/table";
import Toggle from "../../../../ui/toggle/toggle";
import ThreeDotsIcon from "../../../../modules/icons/threedots";
import ButtonDropdownMenu from "../../../../ui/dropdownmenu/buttondropdownmenu/buttondropdownmenu";
import ReportIcon from "../../../../modules/icons/report";
import EditIcon from "../../../../modules/icons/edit";
import DetailsIcon from "../../../../modules/icons/details";
import "./adstations.scss"
import CodeIcon from "../../../../modules/icons/code";
import CopyIcon from "../../../../modules/icons/copy";
import {useEffect, useState} from "react";
import Table from "../../../../ui/table/table";
import TableHeaderContent from "../../../../ui/tableheadercontent/tableheadercontent";
import CreateAdStation from "./createadstation/createadstation";
import {useNavigate} from "react-router-dom";

const AdStations = () => {
    const navigate = useNavigate();
    const contentHeaderBox: JSX.Element = (
        <>
            <Button type={"filter"} action={() => {
            }} responsive={true}>
                <CodeIcon/>
                &nbsp;&nbsp;
                دریافت کد اسکریپت
            </Button>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <Button type={"secondary"} action={() => {
                localStorage.setItem("createAdStation", "true");
                navigate(0);
            }} responsive={true}>
                <AddCircleOutlineOutlinedIcon/>
                &nbsp;&nbsp;
                ایجاد رسانه جدید
            </Button>
        </>
    )
    const buttonDropMenu = (
        [
            {
                icon: <ReportIcon/>, title: 'گزارش', action: () => {
                }
            },
            {
                icon: <EditIcon/>, title: 'ویرایش', action: () => {
                }
            },
            {
                icon: <DetailsIcon/>, title: 'جزئیات', action: () => {
                }
            },
        ]
    )
    const tableData: SimpleTable = {
        headers: ["شناسه", "نام", "شناسه بر حسب جایگاه", "کد HTML", "نوع رسانه", "نوع جایگاه", "وضعیت", "فعالیت", "عملیات"],
        bodies: [
            ["1793", "بنری", "کمپین روز مادر",
                <div>کپی کنید !&nbsp;&nbsp;&nbsp;&nbsp;<span className="Copy-Icon"><CopyIcon/></span>
                </div>, "بنری", "بنری",
                <span data-status={"verified"} className="Table-Status">تایید شده</span>, <Toggle onClick={() => {
            }} checked={true}/>, <ButtonDropdownMenu icon={<ThreeDotsIcon/>} menuItems={buttonDropMenu}/>],
            ["1071", "همسان", "موبایل سامسونگ",
                <div>کپی کنید !&nbsp;&nbsp;&nbsp;&nbsp;<span className="Copy-Icon"><CopyIcon/></span>
                </div>, "همسان", "همسان",
                <span data-status={"pending"} className="Table-Status">در حال بررسی</span>, <Toggle onClick={() => {
            }} checked={true}/>, <ButtonDropdownMenu icon={<ThreeDotsIcon/>} menuItems={buttonDropMenu}/>],
            ["5380", "ویدیویی", "نوتیف/مشهد/موبایل", <div></div>, "ویدیویی", "ویدیویی",
                <span data-status={"verified"} className="Table-Status">تایید شده</span>, <Toggle onClick={() => {
            }} checked={true}/>, <ButtonDropdownMenu icon={<ThreeDotsIcon/>} menuItems={buttonDropMenu}/>],
            ["5389", "محصول", "لپ تاپ",
                <div>کپی کنید !&nbsp;&nbsp;&nbsp;&nbsp;<span className="Copy-Icon"><CopyIcon/></span>
                </div>, "محصول", "محصول",
                <span data-status={"verified"} className="Table-Status">تایید شده</span>, <Toggle onClick={() => {
            }} checked={true}/>, <ButtonDropdownMenu icon={<ThreeDotsIcon/>} menuItems={buttonDropMenu}/>],
            ["5387", "تیزر استانی", "کت چرم",
                <div>کپی کنید !&nbsp;&nbsp;&nbsp;&nbsp;<span className="Copy-Icon"><CopyIcon/></span>
                </div>, "تیزر استانی", "تیزر استانی",
                <span data-status={"verified"} className="Table-Status">تایید شده</span>, <Toggle onClick={() => {
            }} checked={false}/>, <ButtonDropdownMenu icon={<ThreeDotsIcon/>} menuItems={buttonDropMenu}/>],
            ["5391", "گوگل", "تخفیف دوره ای",
                <div>کپی کنید !&nbsp;&nbsp;&nbsp;&nbsp;<span className="Copy-Icon"><CopyIcon/></span>
                </div>, "گوگل", "گوگل",
                <span data-status={"pending"} className="Table-Status">در حال بررسی</span>, <Toggle onClick={() => {
            }} checked={false}/>, <ButtonDropdownMenu icon={<ThreeDotsIcon/>} menuItems={buttonDropMenu}/>],
            ["5393", "رپورتاژ آکهی", "نوتیف/تهران/موبایل و دسکتاپ", <div></div>, "رپورتاژ آکهی", "رپورتاژ آکهی",
                <span data-status={"pending"} className="Table-Status">در حال بررسی</span>, <Toggle onClick={() => {
            }} checked={false}/>, <ButtonDropdownMenu icon={<ThreeDotsIcon/>} menuItems={buttonDropMenu}/>],
            ["4148", "شبکه اجتماعی", "بنر فروش فوق‌العاده", <div></div>, "شبکه اجتماعی", "شبکه اجتماعی",
                <span data-status={"pending"} className="Table-Status">در حال بررسی</span>, <Toggle onClick={() => {
            }} checked={false}/>, <ButtonDropdownMenu icon={<ThreeDotsIcon/>} menuItems={buttonDropMenu}/>],
        ]
    }
    const [createNew, setCreateNew] = useState(false);
    useEffect(() => {
        localStorage.getItem("createAdStation") === 'true' ? setCreateNew(true) : setCreateNew(false);
    }, [])
    return (
        <div className="Publisher-Ad-Stations">
            {
                createNew ?
                    null :
                    <UserContentHeader title={'رسانه های تبلیغات من'}
                                       subtitle={"در لیست زیر می توانید تمام کمپین های خود را مشاهده کنید."}
                                       icon={<></>}
                                       iconColor={"#EF233C"}
                                       box={contentHeaderBox}/>
            }
            {/*<DataNotFound image={require("../../../../assets/images/icons/DataNotFound2.svg").default}*/}
            {/*              title={"هیچ داده ای برای نمایش وجود ندارد"}*/}
            {/*              body={"برای شروع کار یک کمپین بسازید. کمپین ها به شما کمک می کنند که تبلیغات خود را \n" +*/}
            {/*                  "به آسانی  و با شرایطی که میخواهید ، نمایش دهید."}/>*/}
            {
                createNew ?
                    <CreateAdStation/> :
                    <>
                        <Table
                            headers={tableData.headers}
                            bodies={tableData.bodies}
                            headerContent={<TableHeaderContent title={"لیست رسانه ها"} subtitle={""}
                                                               placeholder={"جستجوی رسانه"} onClick={() => {
                            }}/>}
                            rowEachPage={8}/>
                    </>
            }
        </div>
    )
}

export default AdStations;